// extracted by mini-css-extract-plugin
export default {"revenueContent":"Summary_revenueContent__-KKJW"};